import { Component, Input, OnInit } from "@angular/core";
import { DashboardMultiStationService } from "../dashboard-multistation.service";

@Component({
	selector: "caass-ms-station-status",
	templateUrl: "./ms-station-status.component.html",
	styleUrls: ["./ms-station-status.component.css"],
})
export class MsStationStatusComponent implements OnInit {
	constructor(private visitorService: DashboardMultiStationService) {}

	ngOnInit(): void {
		this.loadData();
	}

	ngOnChanges() {
		this.loadData();
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	@Input() FacilityID: number = -1;

	Inited: boolean = false;

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: boolean = false;

	//Main
	SelectedScanStation: any;
	lstScanStation: any = [];

	//Filter lists
	lstIsScanStationDesc: any = [];
	lstFacilityName: any = [];
	lstFacilityLocationName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ScanStation", header: "Station Name" },
		{ field: "FacilityName", header: "Facility" },
		{ field: "FacilityLocationName", header: "Location" },
		{ field: "IsScanStationDesc", header: "Running ScanStation" },
	];

	OptionID: number = 0;
	Title: string = "Facility";

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////

	loadData() {
		this.ClearData();

		if (this.FacilityID == undefined || this.FacilityID < 0) {
			return;
		}

		this.loading = true;

		var result = this.visitorService.VisitorScanStationInfoSelectList(this.OptionID == 0 ? this.FacilityID : -1);
		result.subscribe(
			(response: any) => {
				this.lstScanStation = response;

				//Load Data Filter Lists
				this.lstIsScanStationDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsScanStationDesc))).sort();
				this.lstFacilityName = Array.from(new Set(this.lstScanStation.map((item: any) => item.FacilityName))).sort();
				this.lstFacilityLocationName = Array.from(new Set(this.lstScanStation.map((item: any) => item.FacilityLocationName))).sort();

				if (this.Inited == false) {
					this.Inited = true;
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////

	SelectOption(opt) {
		this.OptionID = opt;

		if (this.OptionID == 0) {
			this.Title = "Facility";
		} else if (this.OptionID == 1) {
			this.Title = "District";
		}

		this.loadData();
	}
	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////
	onRowSelect(val) {
		this.SelectedScanStation = val.data;
	}
	onRowUnselect(val) {
		this.SelectedScanStation = null;
	}
	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////

	ClearData() {
		this.lstScanStation = [];
		this.lstIsScanStationDesc = [];
	}

	//////////////////////////////////////////////////////////
}
